<template>
    <div id="contact-page">
        <!--================ About History Area  =================-->
        <section class="about_history_area section_gap append_gap">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 d_flex align-items-center">
                        <div class="about_content " style="width:100%">
                            <h2 class="title title_color">訂房流程<br>&<br>取消規定 <br></h2>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img class="img-fluid" src="../assets/news/bed-bedroom-bedsheet-2387753.jpg" alt="img">
                    </div>
                </div>
                <div class="row about_travel_intro">
                    <div class="col-md-12 d_flex align-items-center">
                        <div class="about_content ">
                            <h2 class="title title_color"></h2>
                            <p><small> + 先了解訂房與取消規定，更快速的完成預訂</small></p>
                        </div>
                    </div>
                </div>

                <div class="contact-way">
                    <div class="contact-way-area row justify-content-around">
                        <div class="way-by-public contact-way-type col-md-10">
                            <div class="way-name">訂房流程</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>◎ 請詳讀<span class="cursor_btn hint-color" @click="goPreknow()">「訂房前須知&住宿約定」</span>再行預訂，以確保您的權益。</div><br/>
                                
                                <div>官網線上訂房</div>
                                <ol>
                                    <li>預定時，如房型未提供加床選項，則表示該房型不允許加床，請根據房型人數入住。（如：雙人房最多兩位入住、四人房最多四位入住、六人房最多六位入住）</li>
                                    <li>於官網預訂過程中，必須填入正確信用卡資訊作為保證訂房用（故無需再預付訂金），我們不會預先刷取您的全額房費。但如填寫之信用卡不正確，我們將會通知您匯款訂金或取消您的預定。</li>
                                    <li>預定時，請務必填寫正確的email，並於預定完成後，確認<span class="hint-color">是否成功收到訂房確認通知信</span>。如未收到，請再聯繫我們來確認您的預定是否成功。</li>
                                    <li>於官網線上預訂，如有未如期入住等情況，根據官網預訂取消辦法，將直接從您的信用卡扣取全額房費。</li>
                                    <li>在官網預定房間，<span class="hint-color">如有特殊需求是官網無法選擇或加購的，敬請直接與我們聯繫確認</span>，並未所有您提出的需求都是允許或有提供的。</li>
                                    <li>入住時，請攜帶身份證件登記，<span class="hint-color">若會超過21:00，請主動來電告知，並視情況酌收延遲抵達費，若超過午夜00:00，恕一律無法接待，不予退費</span>，逾時且未提前告知視同入住，房間不予保留(更改日期)，訂金不予退費​</li>
                                    <li>寵物入住之預訂，請選擇寵物房型。</li>
                                </ol>

                                <div>OTA訂房｜Agoda、Booking、Expedia 等</div>
                                <ol>
                                    <li>在OTA各大訂房平台上之預訂，是屬於您與其訂房平台之協議，故預訂、折扣、取消辦法將依照各訂房平台及訂單類型之相關規定。
                                    </li>
                                    <li>針對在訂房平台之預訂發生訂單內容錯誤、訂房失敗、欲取消訂房或修改訂房內容等事宜，因您並非直接透過民宿方做預訂，故我們無權能夠修改，僅能配合您與訂房平台商量後的結果，請直接與其訂房平台聯繫。</li>
                                    <li>部分OTA平台因無需預填信用卡資訊即可訂房，為保證您確定入住，民宿方將會透過訂房平台傳訂房確認簡訊，請您預付訂金，敬請留意，以免被取消預訂。</li>
                                    <li><span class="hint-color">如有特殊需求，敬請直接與我們聯繫確認</span>，並未所有您提出的需求都是允許或有提供的。</li>
                                    <li>入住時，請攜帶身份證件登記，<span class="hint-color">若會超過21:00，請主動來電告知，並視情況酌收延遲抵達費，若超過午夜00:00，恕一律無法接待，不予退費</span>，逾時且未提前告知視同入住，房間不予保留(更改日期)，訂金不予退費​</li>
                                    <li>不接受寵物入住之預訂。</li>
                                
                                </ol>
                                <!--
                                <div>寵物入住客服訂房｜電話、LINE </div>
                                <ol>
                                    <li>客服訂房時間早上9:00至晚上6:00，請配合於訂房時間詢問或來電。</li>
                                    <li>為提供優良的服務品質，詢問時，請告知預計入住日期、房型、幾大幾小幾寵。</li>
                                    <li>經訂房確認後，您將會收到訂房確認簡訊<span class="hint-color">(若超過24hr未收到簡訊者請盡速跟我們聯絡)</span>，請根據訊息內容，於二日內將訂金匯入(房價的30%。若入住期間為三日以上之連續假日，訂金為房價的50%)</li>
                                    <li>匯款後請務必主動以<a href="line://ti/p/@bmj3918o">LINE</a>回覆通知我們，並且告知帳號末五碼(官方LINE ID: <a href="line://ti/p/@bmj3918o">@bmj3918o </a>)。</li>
                                    <li>我們於收到您的匯款通知後，5日內會確認並回覆您，餘款於入住當日付清即可。</li>
                                    <li><span class="hint-color">若於保留時間內未收到匯款訂金，經一次提醒仍未答覆，則將直接取消您的訂房。</span></li>
                                    <li>入住時，請攜帶身份證件登記，<span class="hint-color">若會超過21:00，請主動來電告知，並視情況酌收延遲抵達費，若超過午夜00:00，恕一律無法接待，不予退費</span>，逾時且未提前告知視同入住，房間不予保留(更改日期)，訂金不予退費​</li>
                                </ol>
                                -->
                            </div>
                        </div>
                        <div class="way-by-public contact-way-type col-md-10">
                            <div class="way-name">匯款資訊</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div></div>
                                <span>國泰世華銀行 013</span><br/>
                                <span>分行名稱：台東分行</span><br/>
                                <span>戶名：黃建彰</span><br/>
                                <span>銀行帳號：102-50-617130-7 </span>
                            </div>
                        </div>
                        <div class="way-by-private contact-way-type col-md-10">
                            <div class="way-name">取消流程</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div></div>
                                <ul>
                                    依照民宿定型化契約，對消費者及商家有保障
                                    <li>若於入住日前 14 日以上通知取消訂房者，可退回全額保證金。</li>
                                    <li>若於入住日前 10 至 13 日通知取消訂房者，可退回保證金 70%。</li>
                                    <li>若於入住日前 7 至 9 日通知取消訂房者，可退回保證金 50%。</li>
                                    <li>若於入住日前 4 至 6 日通知取消訂房者，可退回保證金 40%。</li>
                                    <li>若於入住日前 2 至 3 日通知取消訂房者，可退回保證金 30%。</li>
                                    <li>若於入住前 1 日通知取消訂房者，可退回保證金 20%。</li>
                                    <li>若於入住當日通知取消或未告知取消預訂者，則保證金將全額沒收不予退還。</li>
                                    <li>若需延期住宿，請於入住前 14 日告知，並可辦理保留 3 個月之期限，請於期限內之入住日使用，逾期將視同放棄。</li>
                                    <li>為保障其他訂房客人權利，改( 延) 期住宿僅能同意變更一次，無法接受一直變換住宿日期，改( 延) 期住宿後則不再接受取消。</li>
                                    <li>如遇颱風、地震等天災，交通因中斷，經台東縣政府或旅客所在地政府發佈停止上班上課，方可退還訂金或保留訂金三個月並擇期入住。</li>
                                </ul>
                            </div>
                            <div>（OTA訂房，以訂房平台之各訂單規定為主）</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--================ About History Area  =================-->
    </div>
</template>

<script>

export default {
  name: 'requlation',
  components: {},
  methods: {
    goPreknow () {
      this.$ga.event('know', 'click-know', 'preknow', 1)
      this.$router.push({name: 'Know'})
    }
  }
}
</script>
<style lang="scss">
$contact-info-color: #2f2f2f;
.hint-color {
    color: brown;
}
.about_contact_info {
    max-width: 300px;
    margin: auto;
    text-align: left;
}
.about_travel_intro {
    text-align: left;
    border-top: 2px solid;
    margin-top: 20px;
}
#contact-page {
    .contact-way {
        padding: 5rem 16px;
        background: rgba(0, 0, 0, 0.1);
        position: relative;
        // &:before {
        //     content: '';
        //     position: absolute;
        //     top: 0;
        //     /* border-bottom: 25px rgba(0, 0, 0, 0.1) solid; */
        //     border-right: 25px rgba(0, 0, 0, 0.1);
        //     border-left: 25px rgba(0, 0, 0, 0.1) solid;
        //     border-top: 25px solid white;
        //     left: 50%;
        //     margin-left: -25px;
        // }
        .title {
            font-size: 32px;
            font-weight: 100;
            color: #000;
            // margin-bottom: 5rem;
        }
        .contact-way-area .contact-way-type {
            .way-name {
                color: #FF6161;
                font-size: 18px;
                text-align: center;
                transition: 1s ease;
            }
            .way-detail {
                margin-top: 10px;
                & > div {
                    font-weight: 600;
                }
            }
            .short-border {
                width: 4rem;
                height: 1px;
                background: #FF6161;
                margin: .5rem auto 2rem auto;
            }
            // padding: 5rem 4.5rem;
            // background: rgba(4, 81, 132, 1);
            // color: white;
            // font-weight: 100;
            letter-spacing: 1px;
            text-align: left;
            transition: 1s ease;
            margin-bottom: 60px;
            // &:hover {
            //     background: #000;
            //     .way-name {
            //         font-size: 32px;
            //     }
            // }
        }
        .contact-way-direction {
            img {
                width: 80%;
                max-width: 600px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Regulation.vue